
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { RapporteditorTextField } from './RapporteditorTextField';

export interface IRapporteditorAssociatedFieldProps {
  field: {
    Name: string;
    Caption: string;
    Width?: number;
    NewRow?: boolean;
    EditBox?: boolean;
  };
  customField?: boolean;
  association?: string;
  onFieldChange: (updatedField: any) => void;
}

export const RapporteditorAssociatedField: React.FC<
  IRapporteditorAssociatedFieldProps
> = props => {
  const { field, customField, association, onFieldChange } = props;
  return (
    <Box>
      <RapporteditorTextField
        label="Fält"
        field="Name"
        value={field}
        onChange={(newField, selectedNode) => {
          if (selectedNode) {
            if (!newField.Caption) {
              newField.Caption = selectedNode.displayName;
            }
            onFieldChange(newField);
          } else {
            onFieldChange(newField);
          }
        }}
        allowModelSelect
        selectFromAssociation={association}
      />
      <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start' }}>
        <Box sx={{ flex: '0 0 70%' }}>
          <RapporteditorTextField
            label="Rubrik"
            field="Caption"
            value={field}
            onChange={onFieldChange}
          />
        </Box>
        <Box>
          <RapporteditorTextField
            label="Bredd (mm)"
            field="Width"
            value={field}
            onChange={onFieldChange}
            numeric
          />
        </Box>
      </Box>
      {customField && (
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start' }}>
          <Box sx={{ flex: '0 0 30%' }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={!!field.EditBox}
                  onChange={e => {
                    onFieldChange({
                      ...field,
                      EditBox: e.target.checked,
                    });
                  }}
                />
              }
              label="Editerbar"
              sx={{ marginTop: -2 }}
            />
          </Box>
          <Box>
            <FormControlLabel
              control={
                <Checkbox
                  checked={!!field.NewRow}
                  onChange={e => {
                    onFieldChange({
                      ...field,
                      NewRow: e.target.checked,
                    });
                  }}
                />
              }
              label="Ny rad"
              sx={{ marginTop: -2 }}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
};
